import { createReducer } from '@reduxjs/toolkit';
import { updateFieldInteraction, updateVideoSoundPreference } from './actions';
import { userInteractionInitialState } from './state';

export const userInteractionReducer = createReducer(userInteractionInitialState, (builder) => {
  builder.addCase(updateFieldInteraction, (state, { payload }) => {
    if (!state[payload]) {
      return state;
    }

    return { ...state, [payload]: { ...state[payload], isChanged: true } };
  });
  builder.addCase(updateVideoSoundPreference, (state, { payload }) => {
    state.isVideoSoundEnabled = payload;
  });
});
